(ns ycweb.app.website.dlp.competition-success
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]))

(rum/defc competition-success-page < rum/reactive [app-atom]
  (web-common/set-meta-title! "Yuppiechef | Thank You for entering")
  [:main#main-content.yc-page-content.yc-page-content--standard
   [:div.yc-section.yc-section--large
    (headings/heading "Thank you for your entry"
      {:type :h1 :size :large :center true})
    [:p.yc-paragraph.u-text-center
     "We've got your entry. Cross your fingers and hang in there - the lucky winner will be announced shortly."]
    [:div.u-block-center.u-max-width-240
     (buttons/button-web "Return to Homepage"
       {:href "/index.htm" :style :dark :full true})]]])

(defmethod flow/render-screen :web.competition-success [app-atom _]
  (website/screen-wrapper app-atom
    (competition-success-page app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))
